import { appStoreVisitRedirect } from '@api/mobile-redirect';
import { flattenQueryParam } from '@src/utils/request';
import { isIphone } from '@utils/client';
import { MobileRedirectParams } from 'types/mobile-redirects';
import { RouteConfig } from 'vue-router';

const mobileRedirectRoutes: Array<RouteConfig> = [
	{
		path: '/play-store-redirect',
		name: 'play-store-redirect',
		beforeEnter: async (to) => {
			const params: MobileRedirectParams = {
				utmCampaign: flattenQueryParam(to.query.utm_campaign) ?? null,
				utmContent: flattenQueryParam(to.query.utm_content) ?? null,
				utmMedium: flattenQueryParam(to.query.utm_medium) ?? null,
				utmSource: flattenQueryParam(to.query.utm_source) ?? null,
				distinctId: flattenQueryParam(to.query.distinct_id) ?? null,
				clickId: flattenQueryParam(to.query.clickid) ?? null,
				appType: 'GOOGLE_PLAY'
			};

			const mobileRedirectLink = await appStoreVisitRedirect(params);
			window.location.href = mobileRedirectLink.appRedirect;
		}
	},
	{
		path: '/app-store-redirect',
		name: 'app-store-redirect',
		beforeEnter: async (to) => {
			const params: MobileRedirectParams = {
				utmCampaign: flattenQueryParam(to.query.utm_campaign) ?? null,
				utmContent: flattenQueryParam(to.query.utm_content) ?? null,
				utmMedium: flattenQueryParam(to.query.utm_medium) ?? null,
				utmSource: flattenQueryParam(to.query.utm_source) ?? null,
				distinctId: flattenQueryParam(to.query.distinct_id) ?? null,
				clickId: flattenQueryParam(to.query.clickid) ?? null,
				appType: 'APPLE_APP_STORE'
			};

			const mobileRedirectLink = await appStoreVisitRedirect(params);
			window.location.href = mobileRedirectLink.appRedirect;
		}
	},
	{
		path: '/invest-now',
		name: 'invest-now',
		beforeEnter: async (to, from, next) => {
			if (isIphone()) {
				next({ name: 'app-store-redirect', query: to.query });
			} else {
				next({ name: 'start-investing', query: to.query });
			}
		}
	}
];

export default mobileRedirectRoutes;
